module.exports = [["KEEP","action:mmGps,mmDistance,mmH264,mmH264Meta,mmDoppler,mmDopplerCalibration,mmAlpr"],["SKIP","action:mmAlpr","sender~msvcAlpr$"]]